import type { IconData } from '@stacksjs/iconify-core'

export const arrowRightCircle1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M45 24a21 21 0 1 1-42 0a21 21 0 1 1 42 0\"/><path d=\"M24.146 23.646a.5.5 0 0 1 0 .707l-6.498 6.499c-.97.97-1.169 2.486-.29 3.538c.701.839 1.537 1.673 2.392 2.275c1.008.709 2.302.377 3.218-.447c3.274-2.941 7.602-7.328 9.779-10.21c.92-1.219.919-2.798 0-4.016c-2.177-2.883-6.505-7.269-9.779-10.21c-.916-.824-2.21-1.156-3.218-.448c-.855.602-1.69 1.437-2.392 2.275c-.879 1.052-.68 2.57.29 3.539z\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default arrowRightCircle1
